var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 9,
  height: 8,
  viewBox: "0 0 9 8"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M118.358,142.5l-3.926-2.929,1.116-1.372,2.411,1.8,3.979-5.5,1.493.99Z",
  transform: "translate(-114.432 -134.504)",
  fill: "#fff"
})));
export default __webpack_public_path__ + "static/media/check.94f6fd0f.svg";
export { SvgComponent as ReactComponent };